import { type ReactNode } from 'react';
import { X } from 'lucide-react';
import { Input } from '@/components/ui/input';

export function CollectorFilter({
  value,
  onChange,
}: {
  value: string;
  onChange: (v: string | undefined) => void;
}): ReactNode {
  return (
    <div className="w-36">
      <Input
        placeholder="Collector..."
        value={value}
        onChange={(e) => onChange(e.target.value || undefined)}
      />
    </div>
  );
}

export function ClearFiltersButton({
  onClick,
}: {
  onClick: () => void;
}): ReactNode {
  return (
    <button
      onClick={onClick}
      className="flex items-center gap-1 text-xs text-text-tertiary hover:text-text-primary"
    >
      <X size={12} /> Limpiar
    </button>
  );
}
